require('common/LocalStorage');
require('common/api');

var m = require('am');

m.factory('User', ['$resource', '$http', 'config', '$window', '$cookieStore', '$q',
 function($resource, $http, config, $window, $cookieStore, $q) {
  var $user = $resource(config.api_url + '1/people/:id');

  var promise;
  var current = {};
  var anon = {};
  function get_current() {

    return $http.get(config.api_url + '1/current_user').then(function(response) {
      _.assign(current, response.data);
      $cookieStore.put('username', current.username);
      return current;
    });
  }

  var obj = {
    get: function(obj) {
      return $user.get(obj).$promise.then(function(user) {
        user.$save = function() {
          return $http.put(config.api_url + '1/people/' + user.id, user);
        };
        return user;
      });
    },
    check_access: function(app) {
      obj.current().then(function(user) {
        if (user.id && (!user.apps || user.apps.indexOf(app) === -1)) {
          console.log('Access denied for', app);
          $window.location.assign('/n/');
        }
      });
    },
    resolved: function() {
      if (current.id) {
        return current;
      }
      return anon;
    },
    current: function() {
      if (promise) {
        return promise;
      }

      current.$save = function() {
        return $http.put(config.api_url + '1/people/' + current.id, current);
      };

      Object.defineProperty(current, 'awarded_merits', {
        get: function() {
          return _.indexBy(current.merits, 'name');
        }
      });
      promise = get_current();
      promise.then(function(user) {
        $window.ga('create', config.ga_account, {
          cookieDomain: config.ga_domain,
          clientId: user.id,
          siteSpeedSampleRate: 100
        });
        if (user.primary_tenant) {
          $window.ga('set', 'dimension1', user.primary_tenant.toString());
        }
        $window.ga('set', 'dimension2', user.edition);

        $window.Raven.setUser({
          username: user.username,
          email: user.email
        });
      });

      function refresh() {
        return get_current();
      }
      promise.refresh = refresh;
      current.refresh = refresh;
      return promise;
    }
  };
  return obj;
}]);

m.directive('editUser', ['User', 'change_password', 'notify', function(User, change_password, notify) {
  return {
    // scope: {
    //   editUser: '='
    // },
    templateUrl: require('common/User/my_account.html'),
    replace: 'true',
    controller: ['$scope', function($scope) {
      $scope.data = $scope.editUser;
      $scope.pristine = _.clone($scope.data);

      $scope.update = function(user) {
        user.$save().then(function(){
          notify('Saved', {timeout: 3000});
        });
      };

      User.current().then(function(user) {
        var opts = {
          template: (user.id == $scope.pristine.id ? 'my' : 'user'),
          user_id: (user.id !== $scope.pristine.id ? $scope.pristine.id : undefined)
        };
        $scope.change_password = function() {
          change_password(opts);
        };
      });
    }]
  };
}]);

m.factory('change_password', ['notify', 'modalForm', function(notify, modalForm) {
  return function change_password(user, password) {
    return modalForm({
      template: require('common/User/change_my_password.html'),
      data: {
        current_password: password
      }
    }).then(function(data) {
      return user.$patch({
        password: data.password,
        current_password: data.current_password
      }).then(function() {
        delete user.current_password;
        delete user.password;
        notify('Password Changed', {timeout: 2000});
      }).catch(function() {
        var close = notify.error('Current Password Incorrect', {timeout: 2000});
        return change_password(user, password).then(function(d) {
          close();
          return d;
        });
      });
    });
  };
}]);

m.factory('set_password', ['$http', 'config', '$q', function($http, config, $q) {
  return function set_password(data) {
    return $http.post(config.api_url + '2/account/set_password', data)
      .then(function(response) {
        return response.data;
      })
      .catch(function(response) {
        return $q.reject(response.data);
      });
  };
}]);

m.directive('nameCheck', ['config', '$http', 'throttle', function(config, $http, throttle) {
  var check_name = throttle(function(name, callback) {
    return $http.get(config.api_url + '2/account/name_check/' + name).then(function(response) {
      callback(angular.fromJson(response.data));
    });
  }, 1000);

  return {
    require: 'ngModel',
    link: function($scope, $elem, $attrs, ctrl) {
      function check(name) {
        var opt = $scope.$eval($attrs.nameCheck) || {};
        if (name == opt.current || (_.isArray(opt.current) && _.contains(opt.current, name))) {
          ctrl.$setValidity('nameCheck', true);
        } else if (_.isString(name)) {
          check_name(name, function(data) {
            ctrl.$setValidity('nameCheck', data);
          });
        }
      }
      check(ctrl.$viewValue);
      $scope.$watch(function() {
        return ctrl.$viewValue;
      }, function(name) {
        if (!_(ctrl.$error).omit('nameCheck').any()) {
          check(name);
        }
      });
    }
  };
}]);



/** WEBPACK FOOTER **
 ** /mnt/jenkins/jobs/master/workspace/core/client/common/User/User.js
 **/